// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {Input} from '../../../../hola/pub/lib/input';
import cn from 'classnames';
import styles from './vs_toolip.module.less';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_cta_section_props {
    title: string;
    title_tag?: string;
    subtitle: string;
    caption: string;
}
interface i_cta_section_editor_props {
    value: i_cta_section_props;
    on_change: (v:i_cta_section_props)=>void;
}

export const Cta_section = (props: i_cta_section_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <div className={styles.cta_section}>
      <div className={styles.bg}/>
      <div className={cn(styles.container, theme.container)}>
      <Dynamic_heading tag={props.title_tag || 'h2'}><T>{props.title}</T>
      </Dynamic_heading>
        <p className={cn(theme.mono18, theme.med, theme.color_n600)}>
          <T>{props.subtitle}</T>
        </p>
        <Button
          caption={<Fragment>
            <T>{props.caption}</T> <Arrow_right/>
          </Fragment>}
          size='lg' round={false} to='/dashboard' fit color='black'
        />
      </div>
    </div>;
};

export const Cta_section_editor = (props: i_cta_section_editor_props)=>{
  const {value, on_change} = props;
    return <div>
      <Input
        value={value.title || ''}
        on_change={v=>on_change({...value, title: v})}
        label='Section Title'
      />
      <Title_header_select value={value.title_tag} on_select={v=>
        on_change({...value, title_tag: v})}/>
      <Input
        value={value.subtitle || ''}
        on_change={v=>on_change({...value, subtitle: v})}
        label='Section Subtitle'
      />
      <Input
        value={value.caption || ''}
        on_change={v=>on_change({...value, caption: v})}
        label='Button Caption'
      />
    </div>;
};
